import { createSlice } from '@reduxjs/toolkit';
import {
  getMarketplacesReducers,
  getMarketplaceReducers,
  updateMarketplaceReducers,
  getMarketplacesListReducers,
  getMarketplaceRateLimitReducers,
} from './marketplaces.reducers';

const initialState = {
  marketplace: null,

  marketplaces: [],
  totalMarketplaces: 0,
  totalPages: 0,
  currentPage: 1,

  getMarketplacesStatus: 'idle',
  getMarketplaceStatus: 'idle',
  updateMarketplaceStatus: 'idle',

  list: [],
  getMarketplacesListStatus: 'idle',

  rateLimit: null,
  getMarketplaceRateLimitStatus: 'idle',

  error: null,
};

const marketplacesSlice = createSlice({
  name: 'marketplaces',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getMarketplacesReducers(builder);
    getMarketplaceReducers(builder);
    updateMarketplaceReducers(builder);
    getMarketplacesListReducers(builder);
    getMarketplaceRateLimitReducers(builder);
  },
});

export default marketplacesSlice.reducer;
